import Http from "@/libraries/Http";

export default {
    apiVersion: "v1",
    RESTroute: "milestone-allocations",


    async GET_report(project_id, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/report/${project_id}`,
            { params: params }
        );
    },


    async POST_create(voucher_id, data) {
        return Http.post(
            `/${this.apiVersion}/${this.RESTroute}/create/${voucher_id}`,
            data
        );
    },

    async PUT_update(voucher_id, data) {
        return Http.put(
            `/${this.apiVersion}/${this.RESTroute}/${voucher_id}`,
            data
        );
    },

    async GET_fetchForEditing(voucher_id, params = {}) {
        return Http.get(
            `/${this.apiVersion}/${this.RESTroute}/fetch-for-editing/${voucher_id}`,
            { params: params }
        );
    },

    /**
     * Get all resources
     * GET /resource
     */
    async GET(params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}`, {
            params: params
        });
    },

    /**
     * Get single resource
     * GET /resource/<id>
     */
    async GETS(id, params = {}) {
        return Http.get(`/${this.apiVersion}/${this.RESTroute}/${id}`, {
            params: params
        });
    },

    /**
     * Create resource
     * POST /resource
     * Payload: {}
     */
    async POST(data) {
        return Http.post(`/${this.apiVersion}/${this.RESTroute}`, data);
    },

    /**
     * Put resource
     * PUT /resource/<id>
     * Payload: {}
     */
    async PUT(data) {
        return Http.put(
            `/${this.apiVersion}/${this.RESTroute}/${data.id}`,
            data
        );
    },

    /**
     * Delete resource
     * DELETE /resource/<id>
     */
    async DELETE(id) {
        return Http.delete(`/${this.apiVersion}/${this.RESTroute}/${id}`);
    }
};
